import * as React from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import LocalForm from "./LocalForm";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import LocalEditForm from "./LocalEditForm";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { styled, useTheme } from "@mui/material/styles";
import {
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";

const style = {
	position: "absolute",
	top: "45%",
	left: "50%",
	overflow: "auto",
	maxHeight: "82vh",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	boxShadow: 24,
	borderRadius: "20px",
};

export default function LocalModal(props) {
	const { isEdit, localId } = props;
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

  const theme = useTheme();

	return (
		<div>
			{isEdit === true ? (
				<Button
					onClick={handleOpen}
					color="warning"
					variant="contained"
					size="small"
					startIcon={
						<FuseSvgIcon size={20}>heroicons-solid:pencil-alt</FuseSvgIcon>
					}
				>
					Editar
				</Button>
			) : (
				// <Button
				// 	style={{ marginBottom: "10px" }}
				// 	onClick={handleOpen}
				// 	variant="contained"
				// 	color="info"
				// 	size="small"
				// 	startIcon={<FuseSvgIcon size={20}>heroicons-solid:plus</FuseSvgIcon>}
				// >
				// 	Agregar
				// </Button>
        <Tooltip title="Agregar nuevo local">
          <IconButton
            color="primary"
            onClick={handleOpen}
            sx={{
              bgcolor: theme.palette.primary.main,
              color: "white",
              "&:hover": { bgcolor: theme.palette.primary.dark },
            }}
          >
            <AddCircleOutlineIcon />
          </IconButton>
        </Tooltip>
			)}
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="parent-modal-title"
				aria-describedby="parent-modal-description"
			>
				<Box sx={{ ...style, width: 800 }}>
					{isEdit === true ? (
						<LocalEditForm
							localId={localId}
							handleClose={handleClose}
						/>
					) : (
						<LocalForm handleClose={handleClose}/>
					)}
				</Box>
			</Modal>
		</div>
	);
}
